<app-page-template
  [class.d-none]="isVisibleRangeForm"
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (onAdd)="onCreate()"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
>
  <div class="card-toolbar" after-btns>
    <a
      [matMenuTriggerFor]="addMenu"
      class="btn txt-lg button-shadow tw-ml-2 tw-flex tw-items-center"
      [themeColor]="'btn'"
      mat-ripple
    >
      <span class="tw-mx-1">{{ "common.new" | translate }}</span>
      <i class="mdi mdi-chevron-left mdi-18px tw-text-white"></i>
    </a>

    <mat-menu #addMenu="matMenu" xPosition="after">
      <!-- addSingle -->
      <a
        mat-menu-item
        class="txt-lg button-shadow tw-font-medium tw-flex tw-items-center border-bottom"
        mat-ripple
        (click)="onCreate()"
      >
        <span class="tw-mx-1 text-navyBlue">
          <i
            class="mdi mdi-plus-circle-outline mdi-24px text-navyBlue tw-ml-1"
          ></i>
          {{ pageVocabs + "addBtns.addSingle" | translate }}
        </span>
      </a>
      <!-- addFromFile -->
      <a
        mat-menu-item
        class="txt-lg button-shadow tw-font-medium tw-flex tw-items-center"
        mat-ripple
        (click)="onCreateByRange()"
      >
        <span class="tw-mx-1 text-navyBlue">
          <i
            class="mdi mdi-arrow-left-right mdi-24px text-navyBlue tw-ml-1"
          ></i>
          {{ pageVocabs + "addBtns.createByRange" | translate }}
        </span>
      </a>
    </mat-menu>
  </div>
  <!---------------------------------------- Table Content --------------------------------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
        [ngClass]="currentDateTime > item.expireDate ? 'tr-expired' : ''"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- id -->
        <td class="tw-pr-[15px] ltr:tw-pl-[15px] tw-text-center">
          <span>
            {{ item?.id }}
          </span>
        </td>

        <!-- number -->
        <td>
          <td-value copyToClipboard [value]="item?.number"></td-value>
        </td>

        <!-- smsSenderAgentName -->
        <td>
          <td-value
            copyToClipboard
            [value]="item?.smsSenderAgentName"
          ></td-value>
        </td>

        <!-- smsSenderAgent -->
        <td>
          <span [smsSenderAgent]="item?.smsSenderAgentCp" copyToClipboard>{{
            item?.smsSenderAgentCp | enumToText : SmsSenderAgentCpEnumValues
          }}</span>
        </td>

        <!-- price -->
        <td class="tw-dir-rtl ltr:tw-dir-ltr tw-text-center">
          <td-value
            copyToClipboard
            type="number"
            [value]="item?.price"
          ></td-value>
        </td>

        <!-- isActive -->
        <td>
          <td-value type="boolean" [value]="item?.isActive"></td-value>
        </td>

        <!-- sendToBlackList -->
        <td>
          <td-value type="boolean" [value]="item?.sendToBlackList"></td-value>
        </td>

        <!-- isGeneralBlackList -->
        <td>
          <td-value
            type="boolean"
            [value]="item?.isGeneralBlackList"
          ></td-value>
        </td>

        <!-- created -->
        <td>
          <td-value type="dateTime" [value]="item?.created"></td-value>
        </td>

        <!-- expireDate -->
        <td>
          <td-value type="dateTime" [value]="item?.expireDate"></td-value>
        </td>

        <!-- table operation  -->
        <td class="sticky-td">
          <div
            app-menu-btn
            [matMenuTriggerFor]="menu"
            [isShowDotsMenu]="true"
          ></div>

          <mat-menu #menu="matMenu" xPosition="before">
            <!-- *edit btn -->
            <div app-menu-btn icon="edit" (click)="onUpdate(item.id)"></div>

            <!-- *delete btn -->
            <div
              app-menu-btn
              icon="delete"
              (click)="onDelete(item.id, item.number)"
            ></div>

            <!--*test send btn -->
            <div
              app-menu-btn
              *ngIf="userSession.organizationId() == 1"
              icon="mdi-message-reply-text-outline mdi-18px"
              color="blue"
              title="common.testSend"
              (click)="onTestSend(item.id, item.smsSenderAgentCp)"
            ></div>
          </mat-menu>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!--------------------------------------- Form ---------------------------------------->

<ng-container *ngIf="pageConfig?.isVisibleForm">
  <app-private-numbers-form
    page-form
    [formPageConfig]="formPageConfig"
    (closeFormPage)="getFormResponse($event)"
  >
  </app-private-numbers-form>
</ng-container>

<!--------------------------------------- Form ---------------------------------------->

<ng-container *ngIf="isVisibleRangeForm">
  <app-range-private-numbers-form
    page-form
    [formPageConfig]="formPageConfig"
    (closeFormPage)="getFormResponse($event); isVisibleRangeForm = false"
  >
  </app-range-private-numbers-form>
</ng-container>

<!--------------------------------------- Audit ---------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>

<!---------------------------------------- Help --------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
